var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"text-center",attrs:{"block":""},on:{"click":function($event){return _vm.createInvoice()}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-file-download-outline")]),_vm._v("Download ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }